import { useContext } from 'react';

import { PermissionContext } from 'components/Global/AuthLayout';
import CompanyComponent from 'components/Settings/Masters/Company';

export const Company = () => {
	const context = useContext(PermissionContext);

	return <div>{context.isSuperAdmin && <CompanyComponent />}</div>;
};
